import { render, staticRenderFns } from "./entertongji.vue?vue&type=template&id=35fc367e&scoped=true"
import script from "./entertongji.vue?vue&type=script&lang=js"
export * from "./entertongji.vue?vue&type=script&lang=js"
import style0 from "./entertongji.vue?vue&type=style&index=0&id=35fc367e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc367e",
  null
  
)

export default component.exports